import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm:FormGroup
    returnUrl:any;
    // selectedRole:any;
      constructor(private route:ActivatedRoute,private fb:FormBuilder,private router:Router,private api:ApiService,private observables:ObservablesService) {
        this.loginForm = this.fb.group({
          username:[null,Validators.compose([Validators.required])],
          password:[null,Validators.compose([Validators.required])],
        });

      }

    ngOnInit() {
      localStorage.setItem("logOutStatus",'1')
      localStorage.removeItem("adminLoggedInStatus")
      localStorage.removeItem("subAdminLoggedInStatus")
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    login(value){
      this.api.login(value.username, value.password).then((response:any)=>{
        if(response.status && response.data && response.data.length > 0){
          const user = response.data[0];
          localStorage.setItem("authToken", response.token);
          localStorage.setItem("userId", user.user_id || user.id);
          localStorage.setItem("roleId", user.role_id);
          localStorage.setItem("businessId", user.business_id || '');
          localStorage.setItem("parentId", user.parent_id || '');
          localStorage.removeItem("logOutStatus");

          if(user.role_id == 0 && !user.level){
            localStorage.setItem("superAdminLoggedInStatus","1");
            localStorage.setItem("adminLoggedInStatus","0");
            localStorage.setItem("userLoggedInStatus","0");
            this.observables.showToastMessage({type:0,message:'Logging in...'});
            this.router.navigate(['/super-admin-dashboard']);
          }else if(user.level == 1){
            localStorage.setItem("superAdminLoggedInStatus","0");
            localStorage.setItem("adminLoggedInStatus","1");
            localStorage.setItem("userLoggedInStatus","0");
            this.observables.showToastMessage({type:0,message:'Logging in...'});
            this.router.navigate(['/admin/dashboard']);
          }else{
            localStorage.setItem("superAdminLoggedInStatus","0");
            localStorage.setItem("adminLoggedInStatus","0");
            localStorage.setItem("userLoggedInStatus","1");
            this.observables.showToastMessage({type:0,message:'Logging in...'});
            this.router.navigate(['/user/dashboard']);
          }
        }else{
          const msg = typeof response.data === 'string' ? response.data : 'Username or Password Invalid..';
          this.observables.showToastMessage({type:1, message: msg});
        }
      }).catch(()=>{
        this.observables.showToastMessage({type:1, message:'Login failed. Please try again.'});
      });
    }
}
